import React from 'react';
import styled from 'styled-components';

import ButtonTs from '@lt/components/components/ButtonTs';
import ArrowBack from '@lt/components/icons-react/ArrowBack';
import Settings from '@lt/components/icons-react/Settings';
import NightsPresetPicker from './components/NightsPresetPicker';
import NightsPicker from './components/NightsPicker';
import PickerContainer from '../PickerContainer';
import PickerHeading from '../PickerHeading';

import { DEFAULT_NIGHTS_PRESET, DURATION_PICKER_MODE_NAMES } from './constants';

import type { IDurationPicker } from './types';

import { convertNightsIntervalToPreset } from '../../../../../../../../components/Cigarette/utils';

export const DurationPicker = (props: IDurationPicker): JSX.Element => {
  const {
    selectedMode,
    toggleMode,
    nights,
    nightsPreset,
    selectDuration,
    nightsPresets,
    isMobile,
    isHotelOnly,
    handleNightsButtonClick,
  } = props;

  const isExactMode = selectedMode === DURATION_PICKER_MODE_NAMES.EXACT;

  const nightsIntervalPreset =
    !isExactMode && nights ? convertNightsIntervalToPreset(nights) : undefined;

  return (
    <PickerContainer $isMobile={isMobile} $order={isMobile ? 1 : 2}>
      <PickerHeading>Выберите продолжительность</PickerHeading>
      {isExactMode ? (
        <NightsPicker
          selectedNightsCount={nights || nightsPreset?.value || DEFAULT_NIGHTS_PRESET.value}
          handleSelect={(duration) => {
            handleNightsButtonClick();
            selectDuration(duration);
          }}
          isHotelOnly={isHotelOnly}
        />
      ) : (
        <NightsPresetPicker
          selectedDuration={nightsPreset?.name || nightsIntervalPreset?.name}
          nightsIntervalPreset={nightsIntervalPreset}
          handleSelect={selectDuration}
          nightsPresets={nightsPresets}
          isMobile={isMobile}
        />
      )}
      <StyledContainer>
        <StyledButton variant="functional" onClick={toggleMode}>
          {isExactMode ? <StyledArrowBackIcon /> : <StyledSettingsIcon />}
          <StyledSelectModeText>
            {isExactMode ? 'Рекомендуемые интервалы' : 'Точное количество ночей'}
          </StyledSelectModeText>
        </StyledButton>
      </StyledContainer>
    </PickerContainer>
  );
};

const StyledButton = styled(ButtonTs)`
  display: flex;
  align-items: flex-end;

  margin-top: 4px;

  color: #007aff;
`;

const StyledArrowBackIcon = styled(ArrowBack)`
  width: 15px;
`;

const StyledSettingsIcon = styled(Settings)`
  width: 15px;
`;

const StyledSelectModeText = styled.span`
  margin-left: 4px;
`;

const StyledContainer = styled.div`
  padding: 4px 4px 0 4px;
`;
